import _ from 'lodash';
import { SET_EMAIL_PREFERENCES, SET_IN_PROGRESS, SET_ORIGINAL_STATE } from './actionTypes';

import { DEFAULT_DESKTOP_USER_AGENT, DEFAULT_MOBILE_USER_AGENT } from '@prerender/prerender-shared/FE';

export const defaultDesktopUserAgent = DEFAULT_DESKTOP_USER_AGENT;
export const defaultMobileUserAgent = DEFAULT_MOBILE_USER_AGENT;

const getEmailPreferencesDiff = (original, changed) => {
  const diff = {
    extraRenderEmailOptIn:
      original?.extraRenderEmailOptIn === changed.extraRenderEmailOptIn ? undefined : changed.extraRenderEmailOptIn,
    sendSuggested: original?.sendSuggested === changed.sendSuggested ? undefined : changed.sendSuggested,
    emailReportPeriod:
      original?.emailReportPeriod === changed.emailReportPeriod ? undefined : changed.emailReportPeriod,
    send429Alerts: original?.send429Alerts === changed.send429Alerts ? undefined : changed.send429Alerts,
    aiDiscoverabilityStatusUpdate:
      original?.aiDiscoverabilityStatusUpdate === changed.aiDiscoverabilityStatusUpdate
        ? undefined
        : changed.aiDiscoverabilityStatusUpdate,
  };

  const result = _(diff).omitBy(_.isUndefined).value();

  if (_.isEmpty(result)) return undefined;

  return result;
};

const getDiff = (originalState, state) => {
  const diff = {
    emailPreferences: getEmailPreferencesDiff(originalState?.emailPreferences, state.emailPreferences),
  };

  const result = _(diff).omitBy(_.isUndefined).value();

  if (_.isEmpty(result)) return undefined;

  return result;
};

export const getStateFromPrerenderUser = (prerenderUser) => ({
  recachePaused: prerenderUser.userPausedRecaching,
  emailPreferences: prerenderUser.settings.emailPreferences,
  renderingSettings: {
    desktop: {
      viewPort: prerenderUser.settings.customViewport,
      userAgent: prerenderUser.settings.customDesktopUserAgent,
      enabled: true,
    },
    mobile: {
      viewPort: prerenderUser.settings.customMobileViewport,
      userAgent: prerenderUser.settings.customMobileUserAgent,
      enabled: prerenderUser.mobileAdaptive,
    },
  },
  pageLoadTimeout: prerenderUser.settings.pageLoadTimeout / 1000,
  loadImages: prerenderUser.settings.loadImages,
  renderLocation: {
    changeAvailable: prerenderUser.features.includes('render_location_change'),
    renderRegion: prerenderUser.settings.renderRegion,
  },
  forceHTTPS: prerenderUser.settings.forceHTTPS,
});

const initialState = {
  inProgress: false,
  originalState: null,
  diff: undefined,
  emailPreferences: {
    extraRenderEmailOptIn: true,
    sendSuggested: true,
    emailReportPeriod: 'WEEKLY',
    send429Alerts: true,
    aiDiscoverabilityStatusUpdate: true,
  },
  renderingSettings: {
    desktop: {
      viewPort: { width: 1440, height: 718 },
      userAgent: defaultDesktopUserAgent,
      enabled: true,
    },
    mobile: {
      viewPort: { width: 375, height: 667 },
      userAgent: defaultMobileUserAgent,
      enabled: false,
    },
  },
  pageLoadTimeout: 20,
  loadImages: false,
  renderLocation: {
    changeAvailable: false,
    renderRegion: 'shared',
  },
  forceHTTPS: false,
};

const settingsReducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case SET_ORIGINAL_STATE: {
      if (payload) {
        const originalState = getStateFromPrerenderUser(payload);

        return {
          ...state,
          ...originalState,
          originalState,
          diff: undefined,
        };
      } else {
        return initialState;
      }
    }

    case SET_EMAIL_PREFERENCES: {
      const newState = {
        ...state,
        emailPreferences: payload,
      };

      newState.diff = getDiff(state.originalState, newState);
      return newState;
    }

    case SET_IN_PROGRESS:
      return {
        ...state,
        inProgress: payload,
      };

    default:
      return state;
  }
};

export default settingsReducer;
